import {
  Grid2,
  IconButton,
  InputAdornment,
  Skeleton,
  TextField,
} from "@mui/material";
import VirtualizedTable from "../../components/virtualTable";
import CommonPage from "../../components/common-page";
import { tableLayout } from "./tableLayout";
import FlightTakeoffRoundedIcon from "@mui/icons-material/FlightTakeoffRounded";
import EditAttributesRoundedIcon from "@mui/icons-material/EditAttributesRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import SearchIcon from "@mui/icons-material/Search";
import {
  ContentGrid,
  MetadataGrid,
  Row,
  ScreenshotContainer,
  ScrollableSection,
  TableWrapper,
} from "./style";

export default function ConfigurationsSkeleton() {
  const tableColumns = tableLayout["en"]?.map((column) => column.dataKey);

  const skeletonData = Array(8)
    .fill(null)
    .map((_, index) =>
      tableColumns.reduce((acc, column) => {
        acc[column] = <Skeleton />;
        return acc;
      }, {})
    );
  return (
    <CommonPage>
      <ContentGrid container spacing={4}>
        <Grid2 size={{ md: 12, lg: 6 }}>
          <ScreenshotContainer>
            <Skeleton variant="rectangular" width="100%" height="100%" />
          </ScreenshotContainer>
        </Grid2>

        <MetadataGrid size={{ md: 12, lg: 6 }}>
          <Row center="true" spacebetween="true">
            <Skeleton variant="text" width={200} height={40} />
            <Skeleton variant="circular" width={40} height={40} />
          </Row>

          <Row center="true" spacebetween="true">
            <Skeleton variant="text" width={100} height={32} />
            <Skeleton variant="rectangular" width={200} height={40} />
          </Row>

          <Row>
            <Skeleton variant="text" width={100} height={32} />
            <Skeleton
              variant="rectangular"
              width={80}
              height={32}
              style={{ marginLeft: "8px" }}
            />
            <Skeleton
              variant="rectangular"
              width={80}
              height={32}
              style={{ marginLeft: "8px" }}
            />
            <Skeleton
              variant="rectangular"
              width={80}
              height={32}
              style={{ marginLeft: "8px" }}
            />
          </Row>

          <Skeleton variant="rectangular" width="100%" height={1} />

          <ScrollableSection>
            {Array.from({ length: 8 }).map((_, index) => (
              <Row key={index} center="true" spacebetween="true">
                <Skeleton variant="text" width={120} height={32} />
                <Skeleton variant="rectangular" width={100} height={32} />
              </Row>
            ))}
          </ScrollableSection>
        </MetadataGrid>
      </ContentGrid>

      <Skeleton
        variant="rectangular"
        width="100%"
        height={1}
        style={{ marginBlock: "12px" }}
      />

      <TextField
        disabled
        name="search"
        fullWidth
        variant="outlined"
        size="small"
        placeholder={"..."}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
      />
      <TableWrapper>
        <VirtualizedTable
          columns={tableLayout}
          data={skeletonData}
          height="100%"
          actions={[
            <IconButton color="disabled" disabled>
              <FlightTakeoffRoundedIcon />
            </IconButton>,
            <IconButton color="disabled" disabled>
              <EditAttributesRoundedIcon />
            </IconButton>,
            <IconButton color="disabled" disabled>
              <DeleteRoundedIcon />
            </IconButton>,
          ]}
        />
      </TableWrapper>
    </CommonPage>
  );
}
